import React from 'react';

import cn from 'classnames';

import { i18n } from '../../../../shared/helpers/i18n';
import css from './index.css';

interface Props {
    isCameraEnabled?: boolean;
    isPresenterView?: boolean;
    isPSTNUser: boolean;
}

export const ParticipantVideoPreloader: React.FC<Props> = (props) => {
    const { isCameraEnabled, isPresenterView } = props;
    if (!isCameraEnabled || props.isPSTNUser) {
        return null;
    }

    return (
        <span className={cn(css.Text, { [css.Text_small]: isPresenterView })}>{i18n('statuses', 'video-loading')}</span>
    );
};
